import React from "react";
import "./TeamAndEquipment.css";

const TeamAndEquipment = () => {
  return (
    <div>
      <h1>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cum, minima!
      </h1>
    </div>
  );
};

export default TeamAndEquipment;
